@if (isVisible) {
  <header class="header">
    <!--<main-menu class="header_main-menu"></main-menu>-->
    <!-- Dummy menu for the DEX project -->
    <main-menu-dummy class="header_main-menu"></main-menu-dummy>
    <div class="header_logo">
      <img class="header_logo_img" [attr.src]="logo.img" [attr.alt]="logo.title" [tooltip]="buildInfoText">
    </div>
    <div class="header_controls">
      <language-selector></language-selector>
    </div>
    <link-to-simulator></link-to-simulator>
    @if (!isAdmin) {
      <dyn-xyz-app-header></dyn-xyz-app-header>
    }
    @if (!isGuest) {
      <div class="header_username" [innerHtml]="(displayUsername$ | async) || ''"></div>
    }
  </header>
}
